import React, { useMemo } from "react";
import { connect } from "react-redux";
import FullWidthModal from "@components/common/Modal/FullWidthModal";
import { CUSTOM_MESSAGES, LABEL } from "../../veriables";
import cn from "classnames";
import { TouchableButton } from "../../components/common/Touchable/index";
import ModalHeader from "../../components/common/ModalHeader/index";
import { toWords } from "number-to-words";
import { safeJsonParse } from '@utility/helperFunction';

const TipsConfirmPopUp = (props) => {
  const {
    isOpen,
    onClose,
    onSubmitTips,
    tipAmount,
    totalAmountForTip,
    serverAppTheme,
    isCounter,
    auth,
    isLandScape,
    // seat,
  } = props;

  const seat = safeJsonParse(window.sessionStorage.getItem('seat'), {});

  const popUpModal = useMemo(() => {
    const okButton = {
      backgroundColor: serverAppTheme?.secondaryBtn,
      color: "#ffff",
      border: "none",
      borderRadius: "8px",
    };

    return { okButton };
  }, [serverAppTheme]);

  const formatAmount = (amount) => {
    if (amount == null || isNaN(amount)) return "";

    const fixedAmount = Number(amount).toFixed(2);
    const [dollars, cents] = fixedAmount.split(".");

    const dollarWords = titleCase(toWords(Number(dollars)));
    const centWords =
      cents === "00"
        ? "Zero"
        : titleCase(toWords(Number(cents)));

    return `${dollarWords} Dollars and ${centWords} Cents`;
  }

  const titleCase = (str) => {
    return str
      .split(" ")
      .map(w => w.charAt(0).toUpperCase() + w.slice(1))
      .join(" ");
  }

  const currencySymbol = LABEL().CURRENCY_SYMBOL;

  const checkDecimal = (val) => {
    const newValdata = val.toString().split(".");
    if (newValdata[1]) {
      const newstr = newValdata[1].substring(0, 1);
      if (Number(newstr) > 0) {
        return Number(val).toFixed(1);
      } else {
        return newValdata[0];
      }
    }
    return val;
  };

  const bp = auth?.tipInfo?.basicWarningThresholdPercent;

  return (
    <FullWidthModal
      isOpen={isOpen}
      customClass2={cn("w-100 h-100 position-relative")}
      style={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        height: "100%",
        pointerEvents: "auto",
        backgroundColor: serverAppTheme?.popUp_bg,
        backgroundClip: "padding-box",
        border: "0",
        boxShadow: serverAppTheme?.popUp_box_shadow,
      }}
    >
      <div
        className="col-12 px-0 justify-content-center align-items-center position-relative text-center h-100"
        style={popUpModal.primaryTextColor}
      >
        <div
          className={cn(
            "col-12 px-0 fs_18 align-items-center justify-content-center fw-600 h-100",
          )}
        >
          <ModalHeader
            stationName={seat?.stationName}
            tileHeader="Tip"
            seatNumber={seat?.number}
            isTipWarning={true}
          />
          <div className="align-items-center d-flex fs_24 fw-600 h-85 text-center">
            {checkDecimal(
              ((Number(tipAmount) / totalAmountForTip) * 100).toFixed(1)
            ) > 30 ? (
              <div className="col-12 fw-400">
                <div className="text-center justify-content-center">
                  <div
                    className={cn(isCounter ? 'fs_20 fw-400 mt-2' : 'fs_24 fw-600')}
                  >
                    <div>The entered tip {LABEL().CURRENCY_SYMBOL}{Number(tipAmount)?.toFixed(2)} </div>
                    <div>({formatAmount(tipAmount)})</div>
                    <div> is {checkDecimal(
                      ((Number(tipAmount) / (totalAmountForTip || 1)) * 100)?.toFixed(1)
                    )}% of the check total
                    </div>
                    {/* <div className="fs_20 fw-600 pt-24">
                      {CUSTOM_MESSAGES().Do_you_want_to_continue
                        ? CUSTOM_MESSAGES().Do_you_want_to_continue
                        : 'Do you want to continue ?'}
                    </div> */}
                  </div>
                </div>
              </div>
            ) : checkDecimal(
              ((Number(tipAmount) / totalAmountForTip) * 100).toFixed(1)
            ) == 0 && CUSTOM_MESSAGES().NO_TIP_CONTINUE ? (
              <div className="col-12 fs_18 pb-25 mb-15 fw-400 text-center">
                <div className="fs_18">{CUSTOM_MESSAGES().NO_TIP_CONTINUE}</div>
              </div>
            ) : (
              <div className="col-12 fw-400">
                <div className="text-center justify-content-center pb-25 mb-15">
                  <div className={cn(isCounter ? 'mt-2 fs_20 fw-400' : 'fs_24 fw-600')}>
                    The tip {currencySymbol}
                    {Number(tipAmount).toFixed(2)}, {formatAmount(tipAmount)}, is{' '}
                    {checkDecimal(
                      ((Number(tipAmount) / totalAmountForTip) * 100).toFixed(1)
                    )}
                    %.
                    <br />
                    <div className="fs_20 fw-600 pt-24">
                      {CUSTOM_MESSAGES().Do_you_want_to_continue
                        ? CUSTOM_MESSAGES().Do_you_want_to_continue
                        : 'Do you want to continue ?'}
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
          {isLandScape
            ? (<div className="row">
              <div className={cn("pr-0 pl-4 justify-content-center align-items-center col-12 d-flex")} style={{
                position: 'fixed',
                bottom: '16px',
              }}>
                <div className={cn("col-5 text-center pl-0 pr-2")}>
                  <TouchableButton
                    type="submit"
                    className={cn(
                      "btn-ripple w-100 fs_28 fw-600 od-cancel-btn-bg-color od-cancel-btn-font-color od-cancel-btn-st-color",
                      // style.fw600
                    )}
                    style={{
                      borderRadius: "4px",
                      border: "1px solid #2541A4",
                      backgroundColor: serverAppTheme?.OFF_Premise_Btn,
                      color: serverAppTheme?.primary_text,
                    }}
                    onClick={e => {
                      onClose(false);
                      e.preventDefault();
                    }}
                    rippleEffect={true}
                  >
                    {LABEL().CHANGE_TIP}
                  </TouchableButton>
                </div>
                <div className={cn("col-5 text-center p-0")}>
                  <TouchableButton
                    type="submit"
                    className={cn(
                      "btn-ripple shadow-none border-0 w-100 fs_28 od-primary-btn-bg-color od-primary-btn-font-color fw-600",
                      // style.fw600
                    )}
                    style={{
                      borderRadius: "4px",
                      background: serverAppTheme?.secondaryBtn,
                      color: serverAppTheme?.btn_font_color,
                    }}
                    onClick={e => {
                      e.stopPropagation();
                      e.preventDefault();
                      onSubmitTips();
                    }}
                    rippleEffect={true}
                  >
                    {LABEL().TIPS_CONTINUE}
                  </TouchableButton>
                </div>
              </div>
            </div>)
            : (
              <div
                className={
                  cn(
                    'col-12 d-flex justify-content-center position-absolute p-4',
                    isCounter && 'w-90 px-0'
                  )}
                style={{ bottom: '0' }}
              >
                <div className="col-6 pr-1 pl-0">
                  <TouchableButton
                    type="submit"
                    className={cn(
                      'col-12 btn68 od-cancel-btn-bg-color od-cancel-btn-font-color od-cancel-btn-st-color'
                    )}
                    style={{
                      height: isCounter && '44px',
                      backgroundColor: serverAppTheme?.OFF_Premise_Btn,
                      color: serverAppTheme?.primary_text,
                      border: '1px solid #2541A4',
                    }}
                    onClick={e => {
                      onClose(false);
                      e.preventDefault();
                    }}
                    rippleEffect={true}
                  >
                    <div className={cn('fs_28 fw-600')}>
                      {LABEL().CHANGE_TIP}
                    </div>
                  </TouchableButton>
                </div>
                <div className="col-6 pl-1 pr-0">
                  <TouchableButton
                    type="submit"
                    className={cn(
                      'col-12 btn-ripple btn-lg btn68 od-primary-btn-bg-color od-primary-btn-font-color'
                    )}
                    style={{
                      height: isCounter && '44px',
                      background: serverAppTheme?.secondaryBtn,
                      color: serverAppTheme?.btn_font_color,
                    }}
                    onClick={e => {
                      e.stopPropagation();
                      e.preventDefault();
                      onSubmitTips();
                    }}
                    rippleEffect={true}
                  >
                    <div className={cn('fs_28 fw-600')}>
                      {LABEL().TIPS_CONTINUE}
                    </div>
                  </TouchableButton>
                </div>
              </div>
            )
          }
        </div>
      </div>
    </FullWidthModal >
  );
};

const mapStateToProps = (state) => ({
  serverAppTheme: state.theme.serverAppTheme,
});

export default connect(mapStateToProps)(TipsConfirmPopUp);
